<template>
  <!-- 资讯详情页面 -->
  <div class="liuguirencaiListcontent">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../../assets/images/dongguologo.jpg"
    />
    <div class="Oulist" v-for="(item, index) in arrLIst" :key="index">
      <p class="title">{{ item.Extend1 }}</p>
      <div class="timebox">
        <span>编辑人：韩国东国大学</span>
        {{ item.Extend8 ? item.Extend8.split("T")[0] : "" }}
      </div>
      <div
        class="information"
        v-html="item.InfoHtmlBody ? item.InfoHtmlBody : ''"
      ></div>
      <div class="lablebox">
        <a
          v-for="(itemlable, indexlable) in item.WebSiteLabelList"
          :key="indexlable"
          :href="'/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'"
          target="_blank"
          class="abroadbox_lable"
          >{{ itemlable.WebSiteLabelName }}</a
        >
      </div>
      <ul class="buttonBox">
        <li class="li" @click="Proepages(prevData)">
          <p
            class="left"
            :style="{
              color: prevData != null ? '#333333' : '#999999',
            }"
          >
            上一篇：
          </p>
          <p class="textbox">
            {{ prevData != null ? prevData.Extend1 : "暂无上一篇" }}
          </p>
        </li>
        <li class="line" style="border-bottom: 1px dashed #dddddd"></li>
        <li class="li" @click="Nestpages(nextData)">
          <p
            class="left"
            :style="{
              color: nextData != null ? '#333333' : '#999999',
            }"
          >
            下一篇：
          </p>
          <p class="textbox">
            {{ nextData != null ? nextData.Extend1 : "暂无下一篇" }}
          </p>
        </li>
      </ul>
    </div>
    <div class="xiangguantuijian">
      <p class="ptiele">相关推荐</p>
      <ul>
        <li v-for="(item, index1) in arrLIst1" :key="index1">
          <p class="abroadbox_text" @click="handleClick(item, index1)">
            {{ item.Extend1 }}
          </p>
          <div class="lablebox">
            <a
              v-for="(itemlable, indexlable) in item.WebSiteLabelList"
              :key="indexlable"
              :href="'/biaoqianpage/1-' + itemlable.WebSiteLabelName + '.html'"
              target="_blank"
              class="abroadbox_lable"
              >{{ itemlable.WebSiteLabelName }}</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
export default {
  metaInfo() {
    return {
      title: `${
        this.arrLIst[0] ? this.arrLIst[0].Extend1 : ""
      }-东国资讯-韩国东国大学中文官网`,
      meta: [
        {
          name: "keywords",
          // content: `${this.arrLIst[0] ? this.arrLIst[0].Extend1 : ""}`,
          content: ``,
        },
        {
          name: "description",
          // content: `对${
          //   this.arrLIst[0] ? this.arrLIst[0].Extend1 : ""
          // }进行详细解答,希望能够对各位同学有所帮助,大家一起来看看相关内容吧.`,
            content: ``,
        },
      ],
    };
  },
  data() {
    return {
      arrLIst: [],
      total: 0,
      prevData: {}, //上一篇
      nextData: {}, //下一篇
      //相关推荐
      arrLIst1: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        //初始化列表
        this.getData();
        //  相关推荐
        this.gettuijianData();
      },
    },
  },
  activated() {
    this.$emit("handleTKD", "东国资讯");
  },
  mounted() {
    //初始化列表
    this.getData();
    //  相关推荐
    this.gettuijianData();
  },
  methods: {
    //初始化列表
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuId: Number(this.$route.params.id),
          WebsiteContentId: Number(this.$route.params.WebsiteContentId),
          IsNeedPaging: 1,
          index: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst = res.data.Data.list;
            this.total = res.data.DataCount;
            this.prevData = res.data.Data.PreviousPage;
            this.nextData = res.data.Data.NextPage;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    //上一篇
    Proepages(item) {
      if (item != null) {
        this.toUrl(item);
        this.getData();
      } else {
        Notify({ type: "warning", message: "没有上一篇了哦" });
      }
    },
    //下一篇
    Nestpages(item) {
      if (item != null) {
        this.toUrl(item);
        this.getData();
      } else {
        Notify({ type: "warning", message: "没有下一篇了哦" });
      }
    },
    //id替换
    toUrl(item) {
      this.$router.push({
        name: "listcontent",
        params: {
          id: item.WebsiteMenuId,
          WebsiteContentId: item.WebsiteContentId,
          html: "html",
        },
      });
    },
    // 相关推荐
    gettuijianData() {
      this.$axios
        .post("/trip/TokenPass/GetJRUPublishMenuContent", {
          WebsiteMenuId: Number(this.$route.params.id),
          index: 1,
          size: 6,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst1 = res.data.Data.list;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    //点击进入详情页
    handleClick(item, index) {
      this.$router.push({
        name: "listcontent",
        params: {
          id: item.WebsiteMenuId,
          WebsiteContentId: item.WebsiteContentId,
          html: "html",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.liuguirencaiListcontent {
  width: 750px;
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 134px;
  padding-top: 55px;
  margin-bottom: 60px;
  .Oulist {
    width: 670px;
    margin: 0 auto;
    .title {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 60px;
      white-space: normal;
      word-break: break-all;
    }
    .timebox {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #cccccc;
      margin-top: 21px;
      text-align: center;
      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #cccccc;
        margin-right: 39px;
      }
    }
    /deep/.information {
      margin: 0 auto;
      margin-top: 21px;
      font-size: 30px;
      max-width: 100%;
      word-wrap: break-word;
      img,
      video {
        max-width: 100%;
        max-height: 100%;
        height: auto;
      }
    }
    .lablebox {
      margin-top: 25px;
      margin-bottom: 30px;
      .abroadbox_lable {
        border: 1px solid #f48729;
        border-radius: 4px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f48729;
        height: 32px;
        padding-left: 10px;
        padding-right: 8px;
        margin-left: 10px;
        text-decoration: none;
      }
      .abroadbox_lable:nth-child(1) {
        margin-left: 0px;
      }
    }
    .buttonBox {
      margin: 0 auto;
      width: 670px;
      background: #f8f8f8;
      border-radius: 4px;
      .li {
        width: 590px;
        padding: 30px 0;
        margin: 0 auto;
        display: flex;
        .left {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          width: 100px;
        }
        .textbox {
          width: 490px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 36px;
          height: 36px;
          letter-spacing: 1px;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .line {
        width: 590px;
        margin: 0 auto;
      }
    }
  }
  .xiangguantuijian {
    width: 670px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;
    .ptiele {
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #f48729;
      line-height: 28px;
    }
    ul {
      li {
        margin-top: 20px;
        .abroadbox_text {
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          text-align: justify;
          overflow: hidden;
          white-space: nowrap;
          -o-text-overflow: ellipsis; /* for Opera */
          text-overflow: ellipsis; /* for IE */
        }
        .lablebox {
          margin-top: 14px;
          .abroadbox_lable {
            border: 1px solid #f48729;
            border-radius: 4px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f48729;
            height: 32px;
            padding-left: 10px;
            padding-right: 8px;
            margin-left: 10px;
            text-decoration: none;
          }
          .abroadbox_lable:nth-child(1) {
            margin-left: 0px;
          }
        }
      }
      li:nth-child(1) {
        // padding-top: 0px;
        margin-top: 40px;
      }
    }
  }
}
</style>